/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-wrapper[_ngcontent-%COMP%]{display:block;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,.9);z-index:100000}.spinner-wrapper[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%], .spinner-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:absolute;left:50%;margin-left:-30px;top:50%;margin-top:-30px}.form-group[_ngcontent-%COMP%]   .label-default[_ngcontent-%COMP%]{width:100%}.countChars[_ngcontent-%COMP%]{float:right;color:#ccc}"];
export { styles as styles };
